var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00061 13.1176C9.85946 13.1176 12.177 10.8 12.177 7.94117C12.177 5.08232 9.85946 2.76477 7.00061 2.76477C4.14177 2.76477 1.82422 5.08232 1.82422 7.94117C1.82422 10.8 4.14177 13.1176 7.00061 13.1176Z",
    fill: "#84C70D",
    fillOpacity: 0.29,
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.882812 2.76477C1.54377 1.99702 2.34161 1.35875 3.23572 0.882446",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1185 2.76477C12.4576 1.99702 11.6597 1.35875 10.7656 0.882446",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.11768V7.94116H9.35291",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.11e9e06425a7ea8279bd359cfcda8c58.svg";
export { ForwardRef as ReactComponent };